export default __webpack_public_path__ + "static/media/search.06f62333.svg";